import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "section shortcuts" }
const _hoisted_3 = { class: "apps" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "section help-feedback" }
const _hoisted_9 = { class: "links" }

import { ref, reactive, nextTick } from 'vue'
import CoralLogo from "../assets/images/logos/Coral-Logo-Light.svg"
import BeehiveLogo from "../assets/images/logos/Beehive-Logo-Light.svg"
import HabitatLearnLogo from "../assets/images/logos/Habitat-Learn-Logo-Light.svg"
import MessengerPigeonLogo from "../assets/images/logos/MP-Logo-Light.svg"
import TextButton from "./TextButton.vue"
import IconButton from "../components/IconButton.vue"
import BackArrowLight from "../assets/images/Back-Arrow-Light.svg"
import BackArrowDark from "../assets/images/Back-Arrow-Dark.svg"
import { LINKS } from "../assets/constants"
import FeedbackForm from "../components/FeedbackForm.vue"

interface AppGridSize {
  width: string
  height: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppGrid',
  emits: ["update:visible"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit
const appGridRef = ref()

// Reactive data
const showFeedbackForm = ref<boolean>(false)
const appGridSize = reactive<AppGridSize>({
  width: '',
  height: ''
})

// Methods
const clickBack = (): void => {
  if (appGridRef.value) {
    appGridRef.value.hide()
  }
  emit('update:visible', false)
}

const onHide = (): void => {
  clearFeedback()
  emit('update:visible', false)
}

const onShow = (): void => {
  getSize()
  emit('update:visible', true)
}

const goToURL = (url: string): void => {
  window.location.href = url
}

const openFeedbackForm = (): void => {
  showFeedbackForm.value = true
}

const closeFeedbackForm = (): void => {
  showFeedbackForm.value = false
}

const clearFeedback = (): void => {
  showFeedbackForm.value = false
}

// Method to be called by parent to toggle the popover
const toggle = (event: Event): void => {
  if (appGridRef.value) {
    appGridRef.value.toggle(event)
  }
}

const getSize = (): void => {
  nextTick(() => {
    const el = document.querySelector('.p-popover-content') as HTMLElement
    if (el) {
      appGridSize.width = el.clientWidth + 'px'
      appGridSize.height = el.clientHeight + 'px'
    }
  })
}

// Expose the toggle method for parent component
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_Popover = _resolveComponent("Popover")!
  const _directive_focustrap = _resolveDirective("focustrap")!

  return (_openBlock(), _createBlock(_component_Popover, {
    ref_key: "appGridRef",
    ref: appGridRef,
    class: "app-grid",
    onHide: onHide,
    onShow: onShow
  }, {
    default: _withCtx(() => [
      (!showFeedbackForm.value)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("header", null, [
                _createVNode(IconButton, {
                  icon: _unref(BackArrowLight),
                  "icon-dark": _unref(BackArrowDark),
                  class: "back-arrow",
                  onClick: clickBack,
                  "aria-label": "Back"
                }, null, 8, ["icon", "icon-dark"]),
                _cache[10] || (_cache[10] = _createTextVNode(" Shortcuts "))
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                  autofocus: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (goToURL(_unref(LINKS).MESSENGER_PIGEON))),
                  onKeydown: _cache[1] || (_cache[1] = ($event) => {
              if ($event.key === 'Enter') {
                $event.preventDefault();
                goToURL(_unref(LINKS).MESSENGER_PIGEON);
              }
            }),
                  "aria-label": 'Messenger Pigeon'
                }, [
                  _createElementVNode("img", {
                    role: "presentation",
                    src: _unref(MessengerPigeonLogo),
                    alt: "Messenger Pigeon"
                  }, null, 8, _hoisted_4),
                  _cache[11] || (_cache[11] = _createElementVNode("span", null, "Messenger Pigeon", -1))
                ], 32),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (goToURL(_unref(LINKS).CORAL))),
                  onKeydown: _cache[3] || (_cache[3] = ($event) => {
              if ($event.key === 'Enter') {
                $event.preventDefault();
                goToURL(_unref(LINKS).CORAL);
              }
            }),
                  "aria-label": 'Coral'
                }, [
                  _createElementVNode("img", {
                    role: "presentation",
                    src: _unref(CoralLogo),
                    alt: "Coral"
                  }, null, 8, _hoisted_5),
                  _cache[12] || (_cache[12] = _createElementVNode("span", null, "Coral", -1))
                ], 32),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (goToURL(_unref(LINKS).BEEHIVE))),
                  onKeydown: _cache[5] || (_cache[5] = ($event) => {
              if ($event.key === 'Enter') {
                $event.preventDefault();
                goToURL(_unref(LINKS).BEEHIVE);
              }
            }),
                  "aria-label": 'Beehive'
                }, [
                  _createElementVNode("img", {
                    role: "presentation",
                    src: _unref(BeehiveLogo),
                    alt: "Beehive"
                  }, null, 8, _hoisted_6),
                  _cache[13] || (_cache[13] = _createElementVNode("span", null, "Beehive", -1))
                ], 32),
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (goToURL(_unref(LINKS).HABITAT_LEARN))),
                  onKeydown: _cache[7] || (_cache[7] = ($event) => {
              if ($event.key === 'Enter') {
                $event.preventDefault();
                goToURL(_unref(LINKS).HABITAT_LEARN);
              }
            }),
                  "aria-label": 'Habitat Learn'
                }, [
                  _createElementVNode("img", {
                    role: "presentation",
                    src: _unref(HabitatLearnLogo),
                    alt: "Habitat Learn"
                  }, null, 8, _hoisted_7),
                  _cache[14] || (_cache[14] = _createElementVNode("span", null, "Habitat Learn", -1))
                ], 32)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[15] || (_cache[15] = _createElementVNode("header", null, "Help & Feedback", -1)),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(TextButton, {
                  text: "Products & Services",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (goToURL(_unref(LINKS).HABITAT_LEARN_PRODUCTS)))
                }),
                _createVNode(TextButton, {
                  text: "Help Center",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (goToURL(_unref(LINKS).HABITAT_LEARN_CONTACT)))
                }),
                _createVNode(TextButton, {
                  text: "Submit Feedback",
                  onClick: openFeedbackForm
                })
              ])
            ])
          ])), [
            [_directive_focustrap]
          ])
        : _createCommentVNode("", true),
      _createVNode(_Transition, { name: "slide-up" }, {
        default: _withCtx(() => [
          (showFeedbackForm.value)
            ? (_openBlock(), _createBlock(FeedbackForm, {
                key: 0,
                onClose: closeFeedbackForm,
                onClear: clearFeedback,
                size: appGridSize
              }, null, 8, ["size"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})